import API from "../../api/api";
import React, { Component } from "react";
import "../../styles/css/responsive.css";
import "../../styles/css/dashboard/dashboard.css";
import { Container, Row, Col } from "bootstrap-4-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import ProjectCard from "../../components/ProjectCards/ProjectCard";

import {
  Wrapper,
  ActivityFeed,
  DashboardHeader,
  FinancialStats,
  JobStats,
  UserStats,
} from "../../components";

const userRole = localStorage.getItem("userRole");

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityFeed: "",
      job: "",
      finance: "",
      user: "",
      isDashboardLoading: true,

      detailsData: [],
      jobData: [],

      // searchParams
      // searchKey: "",
      // surveyType: "",
    };
  }

  componentDidMount() {
    API.get("dashboard/admin")
      .then((res) => {
        console.log(res);
        const dashboardData = res.data.response;
        this.setState({
          activityFeed: dashboardData.activity_feed,
          job: dashboardData.job,
          finance: dashboardData.finance,
          user: dashboardData.user,
          isDashboardLoading: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });

    // this.getJobs();
  }
  // async searchJobs(key, type) {
  //   await this.setState({
  //     searchKey: key,
  //     surveyType: type,
  //   });
  //   await this.getJobs();
  // }

  // async getJobs() {
  //   await this.setState({
  //     isDashboardLoading: true,
  //   });
  //   const url =
  //     userRole === "Title Company Admin" || userRole === "Title Company User"
  //       ? "dashboard/title"
  //       : userRole === "Surveyor" ||
  //         userRole === "Surveyor User" ||
  //         userRole === "Admin"
  //       ? "dashboard/survey"
  //       : null;

  //   await API.get(
  //     `${url}?job_name=${this.state.searchKey}&survey_type=${this.state.surveyType}`
  //   )
  //     .then((res) => {
  //       this.setState({
  //         detailsData: res.data.response.card && res.data.response.card,
  //         jobData: res.data.response.jobs && res.data.response.jobs,
  //         isDashboardLoading: false,
  //       });
  //     })
  //     .catch((err) => {
  //       this.setState({ isDashboardLoading: false });
  //       console.log("AXIOS ERROR: ", err);
  //     });
  // }

  render() {
    // const { isDashboardLoading } = this.state;
    const { detailsData, jobData, isDashboardLoading } = this.state;
    console.log(this.state);

    return (
      <Wrapper>
        {isDashboardLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="headerSpace">
            <Container>
              <Row>
                <Col col="sm-12 md-12 lg-12">
                  <div>
                    <DashboardHeader />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col col="sm-12 md-12 lg-12">
                  <UserStats usersData={this.state.user} />
                </Col>
              </Row>
              <Row>
                <Col col="sm-12 md-12 lg-6">
                  <JobStats jobData={this.state.job} />
                </Col>
                <Col col="sm-12 md-12 lg-6">
                  <FinancialStats financeData={this.state.finance} />
                </Col>
              </Row>
              <Row>
                <Col col="sm-12 md-12 lg-12">
                  {/* <div>
                    {jobData &&
                      jobData.map((job) => {
                        return <ProjectCard key={job.id} jobData={job} />;
                      })}
                  </div>{" "} */}
                </Col>
              </Row>

              <Row>
                <Col col="sm-12 md-12 lg-12">
                  <ActivityFeed activityFeed={this.state.activityFeed} />
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </Wrapper>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/AdminDashboard.js